import { render, staticRenderFns } from "./select-brand.vue?vue&type=template&id=678e208b"
import script from "./select-brand.vue?vue&type=script&lang=js"
export * from "./select-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports